import Iconify from '@raas/shared/src/components/minimals/iconify';
import { PATH_DASHBOARD } from '@raas/shared/src/routes/paths';
import { ICON_NAME } from '@raas/shared/src/utils/icons';

const icon = (name: string) => <Iconify icon={name} />;

const ICONS = {
  blog: icon(ICON_NAME.blog),
  downloads: icon(ICON_NAME.downloads),
  gear: icon(ICON_NAME.gear),
  eye: icon(ICON_NAME.eye),
  tags: icon(ICON_NAME.tags),
  alerts: icon(ICON_NAME.alerts),
  reports: icon(ICON_NAME.reports),
  import: icon(ICON_NAME.import),
  tag: icon(ICON_NAME.tag),
  export: icon(ICON_NAME.export),
  requirement: icon(ICON_NAME.requirement),
  input: icon(ICON_NAME.input),
  legal: icon(ICON_NAME.legal),
  delta: icon(ICON_NAME.delta),
  history: icon(ICON_NAME.history),
  integration: icon(ICON_NAME.integration),
  legalRequirement: icon(ICON_NAME.legalRequirement),
  translation: icon(ICON_NAME.translation),
  attribute: icon(ICON_NAME.attribute),
  bundling: icon(ICON_NAME.bundling),
  home: icon(ICON_NAME.home),
};

type NavItem = {
  title: string;
  path: string;
  icon: JSX.Element;
  versionDependent: boolean;
  permissionRequired?: string;
  translationDependent?: boolean;
  disabled?: boolean;
};

type NavSection = {
  subheader: string;
  items: NavItem[];
};

const navConfig: NavSection[] = [
  {
    subheader: ' ',
    items: [
      {
        title: 'Home',
        path: PATH_DASHBOARD.overview.root,
        icon: ICONS.home,
        versionDependent: false,
      },
      {
        title: 'bundling.header',
        icon: ICONS.bundling,
        path: PATH_DASHBOARD.bundling.list,
        versionDependent: true,
      },
      {
        title: 'regulations.page.header',
        icon: ICONS.legal,
        path: '#disabled',
        versionDependent: false,
        disabled: true,
      },
      {
        title: 'legalRequirements.header',
        path: PATH_DASHBOARD.legalRequirement.root,
        icon: ICONS.legalRequirement,
        permissionRequired: 'LEGAL_REQUIREMENTS',
        versionDependent: true,
      },
      {
        title: 'legalProvisions.translationPage.header',
        path: PATH_DASHBOARD.translation,
        icon: ICONS.translation,
        versionDependent: true,
        translationDependent: true,
      },
    ],
  },
  {
    subheader: 'UPDATES',
    items: [
      {
        title: 'History',
        path: '#disabled',
        icon: ICONS.history,
        disabled: true,
        versionDependent: false,
      },
      {
        title: 'Delta',
        path: PATH_DASHBOARD.delta.legalProvisions(),
        icon: ICONS.delta,
        versionDependent: false,
      },
      {
        title: 'Alerts',
        path: PATH_DASHBOARD.alerts.list,
        icon: ICONS.alerts,
        versionDependent: false,
      },
    ],
  },
  {
    subheader: 'DATA MANAGEMENT',
    items: [
      {
        title: 'tagGroups.header',
        path: PATH_DASHBOARD.tagGroup.root,
        icon: ICONS.tags,
        versionDependent: false,
      },
      {
        title: 'tags.header',
        path: PATH_DASHBOARD.tag.root,
        icon: ICONS.tag,
        versionDependent: false,
      },
      {
        title: 'attributes.page.header',
        path: PATH_DASHBOARD.attributes.root,
        icon: ICONS.attribute,
        versionDependent: false,
      },
      {
        title: 'Internal Data',
        path: '#disabled',
        icon: ICONS.gear,
        disabled: true,
        versionDependent: false,
      },
    ],
  },
  {
    subheader: 'EXPORT',
    items: [
      {
        title: 'Exports',
        path: PATH_DASHBOARD.exports.list,
        icon: ICONS.export,
        versionDependent: false,
      },
      {
        title: 'Integration',
        path: PATH_DASHBOARD.integration.root,
        icon: ICONS.integration,
        versionDependent: false,
      },
    ],
  },
];

interface IGetNavPros {
  hasVersion: boolean;
  hasTranslations: boolean;
}

function getNavConfig({ hasVersion, hasTranslations }: IGetNavPros): any {
  if (hasVersion && hasTranslations) {
    return navConfig;
  }

  if (hasVersion && !hasTranslations) {
    return navConfig.map((group) => {
      const items = group.items.filter((i) => !i?.translationDependent);
      return { ...group, items };
    });
  }

  return navConfig.map((group) => {
    const items = group.items.filter((i) => !i.versionDependent && !i?.translationDependent);
    return { ...group, items };
  });
}

export default getNavConfig;
